import { StatusBadge } from "@/components/StatusBadge";
import { User, Phone, MapPin, Ruler, Lock } from "lucide-react";

export const UnitCard = ({ unit, onClick }) => {
  return (
    <button
      data-testid={`unit-card-${unit.unit_number}`}
      onClick={() => onClick(unit)}
      className="text-left bg-white border border-slate-200 rounded-lg p-4 shadow-sm hover:shadow-md hover:border-blue-400 transition-all hover:-translate-y-0.5 cursor-pointer flex flex-col gap-3"
    >
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="font-mono-nums font-bold text-lg text-slate-900 leading-none">{unit.unit_number}</p>
          <span className="mt-1.5 inline-flex items-center gap-1 text-xs text-slate-500">
            <MapPin className="h-3 w-3" /> {unit.site_name}
          </span>
        </div>
        <StatusBadge status={unit.status} unitNumber={unit.unit_number} />
      </div>

      <div className="flex flex-wrap items-center gap-1.5">
        <div className="flex items-center gap-1.5 text-xs font-medium text-slate-600 bg-slate-50 border border-slate-200 rounded px-2 py-1 w-fit">
          <Ruler className="h-3 w-3" /> {unit.size || "—"}
        </div>
        {unit.overdue && <span data-testid={`unit-overdue-${unit.unit_number}`} className="text-[10px] font-bold uppercase rounded bg-red-600 text-white px-1.5 py-0.5">Overdue</span>}
        {unit.gate_locked && <span data-testid={`unit-locked-${unit.unit_number}`} className="inline-flex items-center gap-0.5 text-[10px] font-bold uppercase rounded border border-red-300 bg-red-50 text-red-700 px-1.5 py-0.5"><Lock className="h-3 w-3" /> Locked out</span>}
      </div>

      <div className="space-y-1 border-t border-slate-100 pt-2.5">
        <p className="flex items-center gap-2 text-sm text-slate-800 truncate">
          <User className="h-3.5 w-3.5 text-slate-400 shrink-0" />
          {unit.tenant_name || <span className="text-slate-400 italic">Unassigned</span>}
        </p>
        <p className="flex items-center gap-2 text-sm text-slate-600 truncate">
          <Phone className="h-3.5 w-3.5 text-slate-400 shrink-0" />
          {unit.phone || <span className="text-slate-400">—</span>}
        </p>
      </div>
    </button>
  );
};
